import React from "react";
import ComingSoon from "../../../components/ComingSoon";

export default function Automation() {
  return <ComingSoon title="HR Setup & Automation" />;
}
